export default __webpack_public_path__ + "static/media/illustration-image.bf433f93.png";